import { forwardRef, ReactNode, SVGAttributes } from 'react'

interface IPortIconTemplateProps extends SVGAttributes<SVGElement> {
	size?: string | number
	children: ReactNode
}

export const IPortIconTemplate = forwardRef<SVGSVGElement, IPortIconTemplateProps>((props, ref) => {
	const { children, size = 24, ...rest } = props

	return (
		<svg
			ref={ref}
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...rest}
		>
			{children}
		</svg>
	)
})
